import { render, staticRenderFns } from "./SeminarView.vue?vue&type=template&id=699094f8&scoped=true&"
import script from "./SeminarView.vue?vue&type=script&lang=js&"
export * from "./SeminarView.vue?vue&type=script&lang=js&"
import style0 from "./SeminarView.vue?vue&type=style&index=0&id=699094f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699094f8",
  null
  
)

export default component.exports